<script>
  import {nav} from 'components'
  import {Navigation} from 'components'
  import {Link} from 'components'
  import Help from './Help.svelte'
  import AppPage from './AppPage.svelte'
  import HistoryPage from './HistoryPage.svelte'
  import AboutPage from './AboutPage.svelte'
  import UnknownPage from './UnknownPage.svelte'
  import PageWrap from "./wrap/PageWrap.svelte";
  import User from "./components/User.svelte";
  import Modal from "./components/Modal.svelte"
  import Button from "./components/Button.svelte"
  import {info,host,refresh} from "./components/User.svelte"

  $nav['/'] = AppPage
  $nav['/help'] = Help
  $nav['/about'] = AboutPage
  $nav['/history'] = HistoryPage
  $nav['*'] = UnknownPage

  let modal;
  refresh()

</script>
<Modal bind:this={modal}>Testing TestingTesting TestingTesting TestingTesting TestingTesting Testing
    <div style="margin-top: 20px">
        <Button bgcolor="black">Test</Button>
        <Button bgcolor="gray" on:clicked={modal.close}>Cancel</Button>
    </div>
</Modal>
<div class="navBar">
    <div>
        <b>Timer.today</b>
    </div>
    {#if $info.isLoggedIn}
        <Link href="#/">Home</Link>
        <Link href="#/history">History</Link>
        <Link href="#/help">Help</Link>
        <Link href="#/about">About</Link>
    {/if}
    {#if $info.isLoggedIn} <div style="margin-left: auto;"><User/></div> {/if}
</div>

{#if $info.loading}
      please wait...
    {:else}
    {#if $info.isLoggedIn}
        <PageWrap>
            <Navigation />
        </PageWrap>
    {:else}
        <p>Welcome to Timer.today - the simple time logger.</p>
        Please <Button on:clicked={() => window.location.href=host}>Login</Button> to continue.
    {/if}
    {/if}


<svelte:window on:focus={() => refresh()}/>

<style>
    :global(.selected) {
        background-color: #fa904a;
        color: white;
    }

    .navBar {
        margin-left: auto;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
</style>
